import classNames from "classnames/bind";
import Image from "common/blocks/Image";
import useHasMounted from "hooks/useHasMounted/useHasMounted";
import { ResolvedAuthor } from "resolvers/data/authorResolver";
import dayjs from "utils/dayjs";
import styles from "./ArticleCardAuthor.module.scss";
import UIIcon from "common/blocks/UIIcon";

const cx = classNames.bind(styles);

export interface ArticleCardAuthorProps {
    author: ResolvedAuthor;
    datePublished: string;
    dateModified?: string;
    readTimeMins: number;
}

const ArticleCardAuthor = (props: ArticleCardAuthorProps) => {
    const hasMounted = useHasMounted();

    const {
        datePublished,
        dateModified,
        readTimeMins,
        author: { name, image = { src: "/images/author-fallback.svg", alt: name } },
    } = props;
    const timezone = dayjs.tz.guess();

    return (
        <div className={cx("authorWrap")}>
            <figure className={cx("image")}>
                {!!image?.src && (
                    <Image
                        src={image.src}
                        alt={image?.alt ?? ""}
                        width={40}
                        height={40}
                        layout="intrinsic"
                        objectFit="cover"
                    />
                )}
            </figure>
            <div className={cx("details")}>
                <p className={cx("name")}>{name}</p>
                <p className={cx("postInfo")}>
                    {hasMounted && (
                        <>
                            <UIIcon
                                icon="ClockInvertedColour"
                                className={cx("icon", "clockIcon")}
                            ></UIIcon>
                            {dateModified && (
                                <time dateTime={dateModified}>
                                    {dayjs(dateModified).tz(timezone).format("D MMMM YYYY")}
                                </time>
                            )}
                            {!dateModified && (
                                <time dateTime={datePublished}>
                                    {dayjs(datePublished).tz(timezone).format("D MMMM YYYY")}
                                </time>
                            )}
                        </>
                    )}
                    &nbsp; &#8226; &nbsp;
                    <time dateTime={`PT${readTimeMins}M`} className={cx("time")}>
                        {readTimeMins} min read
                    </time>
                </p>
            </div>
        </div>
    );
};

export default ArticleCardAuthor;
